module.exports = __webpack_public_path__ + "static/media/test_example.bc5fac67.jpg";